var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["modal/user/forgot-password/header.j2"] = require( "modal/user/forgot-password/header.j2" );
dependencies["modal/user/forgot-password/form-field.j2"] = require( "modal/user/forgot-password/form-field.j2" );
dependencies["modal/user/forgot-password/buttons.j2"] = require( "modal/user/forgot-password/buttons.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/user/forgot-password/modal-forgot-password-contents.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "core/templates/modal/user/forgot-password/modal-forgot-password-contents.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_4 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
if(t_1.hasOwnProperty("hasErrors")) {
var t_6 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_6);
if(t_1.hasOwnProperty("validatedField")) {
var t_7 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_7);
output += "\n";
env.getTemplate("macros/urls.j2", false, "core/templates/modal/user/forgot-password/modal-forgot-password-contents.j2", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(t_8.hasOwnProperty("signUpUrl")) {
var t_11 = t_8.signUpUrl;
} else {
cb(new Error("cannot import 'signUpUrl'")); return;
}
context.setVariable("signUpUrl", t_11);
if(t_8.hasOwnProperty("loginUrl")) {
var t_12 = t_8.loginUrl;
} else {
cb(new Error("cannot import 'loginUrl'")); return;
}
context.setVariable("loginUrl", t_12);
if(t_8.hasOwnProperty("homepageUrl")) {
var t_13 = t_8.homepageUrl;
} else {
cb(new Error("cannot import 'homepageUrl'")); return;
}
context.setVariable("homepageUrl", t_13);
output += "\n\n\n";
if(runtime.contextOrFrameLookup(context, frame, "renderedOutsideOfModal")) {
output += "\n\n    <div class=\"s-user-auth-standalone u-clearfix\">\n\n        <div class=\"o-row c-modal-login\" data-qa-modal-signin>\n\n            <div class=\"o-column o-extra-small--12 o-small--8 o-small--centered o-large--5 o-large--centered o-extra-large--4 o-extra-large--centered c-modal-login__form  c-modal-login__section-1 c-modal-login__section-1--password\">\n\n                ";
env.getTemplate("modal/user/forgot-password/header.j2", false, "core/templates/modal/user/forgot-password/modal-forgot-password-contents.j2", null, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
t_14.render(context.getVariables(), frame, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
output += t_15
output += "\n\n                <form novalidate class=\"js-forgot-password-form\" method=\"post\" action=\"\" enctype=\"application/x-www-form-urlencoded\">\n\n                    ";
env.getTemplate("modal/user/forgot-password/form-field.j2", false, "core/templates/modal/user/forgot-password/modal-forgot-password-contents.j2", null, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
t_18.render(context.getVariables(), frame, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
output += t_19
output += "\n\n                    ";
env.getTemplate("modal/user/forgot-password/buttons.j2", false, "core/templates/modal/user/forgot-password/modal-forgot-password-contents.j2", null, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
t_22.render(context.getVariables(), frame, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
output += t_23
output += "\n\n                </form>\n\n            </div>\n\n        </div>\n\n    </div>\n\n";
})})})})})});
}
else {
output += "\n\n    <div class=\" c-modal-login\">\n\n        <form novalidate class=\"js-forgot-password-form\" method=\"post\" action=\"\" enctype=\"application/x-www-form-urlencoded\" data-parsley-validate>\n\n            <div class=\"o-row\" data-qa-modal-signin>\n\n                <div class=\"o-column o-extra-small--12\">\n\n                    <div class=\"c-modal-login__text\">\n\n                        ";
env.getTemplate("modal/user/forgot-password/header.j2", false, "core/templates/modal/user/forgot-password/modal-forgot-password-contents.j2", null, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
t_26.render(context.getVariables(), frame, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
output += t_27
output += "\n\n                    </div>\n\n                </div>\n\n            </div>\n\n            <div class=\"o-row\">\n\n                <div class=\"o-column o-extra-small--12\">\n\n                    ";
env.getTemplate("modal/user/forgot-password/form-field.j2", false, "core/templates/modal/user/forgot-password/modal-forgot-password-contents.j2", null, function(t_32,t_30) {
if(t_32) { cb(t_32); return; }
t_30.render(context.getVariables(), frame, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
output += t_31
output += "\n\n                </div>\n\n            </div>\n\n            <div class=\"o-row\">\n\n                <div class=\"o-column o-extra-small--12 c-modal-login__buttons\">\n\n                    ";
env.getTemplate("modal/user/forgot-password/buttons.j2", false, "core/templates/modal/user/forgot-password/modal-forgot-password-contents.j2", null, function(t_36,t_34) {
if(t_36) { cb(t_36); return; }
t_34.render(context.getVariables(), frame, function(t_37,t_35) {
if(t_37) { cb(t_37); return; }
output += t_35
output += "\n\n                </div>\n\n            </div>\n\n        </form>\n\n    </div>\n\n";
})})})})})});
}
output += "\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/user/forgot-password/modal-forgot-password-contents.j2"] , dependencies)